document.addEventListener("DOMContentLoaded", function () {
  const BUNDLE_COOKIE_NAME = "selected_bundle_products";
  const MAXIMUM_PRODUCTS = 2;

  // === ABConvert: simpel toepassen van testprijzen ===
  const AB_KEY = "abconvert-price-test-experiment-to-group-index";

  /** Lees map { [experimentId]: "0"|"1" } uit localStorage */
  function readAbGroupMap() {
    try {
      const obj = JSON.parse(localStorage.getItem(AB_KEY) || "{}");
      if (obj && typeof obj === "object" && !Array.isArray(obj)) {
        // alles als string normaliseren
        return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, String(v)]));
      }
    } catch { }
    return {};
  }


  function getTestPricingForVariantFromDict(dict, productId, variantId) {
    const prod = dict?.[productId];
    if (!prod || !prod.experimentId) return null;

    const groupMap = readAbGroupMap();
    const gKey = groupMap[prod.experimentId];
    if (gKey == null) return null;

    // per-groep arrays proberen
    const ids = prod.variantIds?.[gKey];
    const prices = prod.variantPrices?.[gKey];
    const compares = prod.variantCompareAtPrices?.[gKey];

    let target = String(variantId);
    if (Array.isArray(ids)) {
      if (!ids.includes(target)) {
        const mapped = prod.variantToVariant?.[gKey]?.[target];
        if (mapped) target = String(mapped);
      }
      const idx = ids.indexOf(target);
      if (idx > -1 && Array.isArray(prices)) {
        return {
          price: Number(prices[idx]),
          compareAt: Array.isArray(compares) ? Number(compares[idx]) : undefined,
          experimentId: prod.experimentId,
          groupIndex: Number(gKey)
        };
      }
    }

    // fallback
    if (prod.variantToPrice?.[target] != null) {
      return {
        price: Number(prod.variantToPrice[target]),
        compareAt: prod.variantToCompareAtPrice?.[target] != null
          ? Number(prod.variantToCompareAtPrice[target])
          : undefined,
        experimentId: prod.experimentId,
        groupIndex: Number(gKey)
      };
    }
    return null;
  }

  // === AB: prijsinhoud primen in kaartjes (géén class/HTML wijzigingen) ===
  // - .price.price--compare  : AB-baseline (variant-specifiek)
  // - .price.price--highlight: AB-baseline - (bundleDiscount/2)
  function primeAbPricesOnCards() {
    const dict = window.abconvertDict || null;
    if (!dict) return;

    const fmtEUR = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;
    const halfDiscount = Number(window.bundleDiscountValue || 0) / 2;

    document.querySelectorAll(".bundle-product").forEach((card) => {
      const productId = card.dataset.mainProductId ? String(card.dataset.mainProductId) : "";
      // variantId heeft voorkeur; val desnoods terug op data-product-id
      const variantId = card.dataset.variantId ? String(card.dataset.variantId) :
        (card.dataset.productId ? String(card.dataset.productId) : "");

      if (!productId || !variantId) return;

      const ab = getTestPricingForVariantFromDict(dict, productId, variantId);
      if (!ab || typeof ab.price !== "number") return;

      const priceList = card.querySelector(".price-list");
      if (!priceList) return;

      console.log("update pricing for card");
      const cmpEl = priceList.querySelector(".price.price--compare");
      const hiEl = priceList.querySelector(".price.price--highlight");
      const priceEl = priceList.querySelector(".normal-price-container .price");

      // Zet compare op AB-baseline (altijd zichtbaar in jouw layout)
      if (cmpEl) {
        cmpEl.innerHTML = `<span class="visually-hidden">Regulärer Preis</span>${fmtEUR(ab.price)}`;
      }
      // Zet highlight alvast klaar (wordt pas zichtbaar door jouw bestaande show-discount toggle)
      if (hiEl) {
        const discounted = Math.max(ab.price - halfDiscount, 0);
        hiEl.innerHTML = `<span class="visually-hidden">Angebotspreis</span>${fmtEUR(discounted)}`;
      }

      if (priceEl) {
        priceEl.innerHTML = `<span class="visually-hidden">Angebotspreis</span>${fmtEUR(ab.price)}`
      }

    });
  }

  async function updateBundleNormalWrapperFromParentAB() {
    const priceEl = document.getElementById("bundle-total-price");
    const compareEl = document.getElementById("bundle-compare-price");
    if (!priceEl) return;

    const fmt = (cents) => Shopify.formatMoney(Math.round(Number(cents || 0)));

    const handle = window.location.pathname.split("/").pop();
    try {
      const parentProduct = await fetch(`/products/${handle}.js`).then(r => r.json());

      // Kies variant: eerst data-parent-product uit DOM, anders 1e variant
      const parentVariantIdFromDom =
        document.querySelector(".ring-product-bundle")?.dataset?.parentProduct || null;

      const variantObj =
        parentProduct.variants?.find(v => String(v.id) === String(parentVariantIdFromDom)) ||
        parentProduct.variants?.[0];

      // Shopify (cents) als baseline
      let baseCents = variantObj?.price ?? parentProduct.price;
      let compareCents = variantObj?.compare_at_price ?? parentProduct.compare_at_price;

      // AB override (EUR → cents), met je bestaande helper
      try {
        const ab = getTestPricingForVariantFromDict(
          window.abconvertDict || null,
          String(parentProduct.id),
          String(variantObj?.id || parentVariantIdFromDom || "")
        );
        if (ab && typeof ab.price === "number") {
          baseCents = Math.round(Number(ab.price) * 100);
          if (ab.compareAt != null) {
            compareCents = Math.round(Number(ab.compareAt) * 100);
          }
        }
      } catch { }

      // UI actualiseren in .bundle-normal-wrapper
      priceEl.style.display = "inline";
      if (compareEl && compareCents != null && Number(compareCents) > Number(baseCents)) {
        compareEl.textContent = fmt(compareCents);
        compareEl.style.display = "inline";
        priceEl.textContent = "ab " + fmt(baseCents);
      } else {
        priceEl.textContent = fmt(baseCents);
        if (compareEl) compareEl.style.display = "none";
      }
    } catch (err) {
      console.error("Error fetching parent product (AB):", err);
    }
  }


  primeAbPricesOnCards();

  /**
   * Vervang prijzen in geselecteerde items o.b.v. abconvertDict.
   * Dict-bedragen zijn in EUR (niet in cents).
   * selected: [{ id, variantId, price, compare_at_price, ... }]
   * return:   zelfde shape, met testprijzen waar van toepassing
   */
function applyAbPricingFromDict(dict, selected) {
  if (!dict || !Array.isArray(selected) || !selected.length) return selected;

  const groupMap = readAbGroupMap();

  return selected.map((p) => {
    const pid = String(p.mainProductId ?? "");
    const currentVid = String(p.variantId ?? p.id);
    if (!pid) return p;

    const prod = dict[pid];
    if (!prod || !prod.experimentId) return p;

    const gKey = groupMap[prod.experimentId];
    if (gKey == null) return p;

    // hulpfunctie: bepaal de variantId die in deze testgroep in de cart moet
    const resolveVariantForGroup = () => {
      const ids = prod.variantIds?.[gKey]; // bv { "1": ["42892222300225"] }
      // 1) expliciete mapping huidig->doel (meest precies)
      const mapped = prod.variantToVariant?.[gKey]?.[currentVid];
      if (mapped) return String(mapped);
      // 2) als huidig al in de groepslijst zit, laat hem zo
      if (Array.isArray(ids) && ids.includes(currentVid)) return currentVid;
      // 3) forceer naar de eerste variant van deze groep
      if (Array.isArray(ids) && ids.length > 0) return String(ids[0]);
      // 4) fallback: niets wijzigen
      return currentVid;
    };

    const targetVid = resolveVariantForGroup();
    console.log(targetVid);
    // --- prijzen op basis van targetVid & group ---
    const ids      = prod.variantIds?.[gKey];
    const prices   = prod.variantPrices?.[gKey];
    const compares = prod.variantCompareAtPrices?.[gKey];

    // 1) per-groep arrays (voorkeursbron)
    if (Array.isArray(ids) && Array.isArray(prices)) {
      const idx = ids.indexOf(targetVid);
      if (idx > -1) {
        const price = Number(prices[idx]);
        const compareAt = Array.isArray(compares) ? Number(compares[idx]) : undefined;
        return {
          ...p,
          variantId: targetVid, // ⬅️ cart gebruikt nu de test-variant
          price,
          compare_at_price: compareAt ?? p.compare_at_price ?? p.price
        };
      }
    }

    // 2) fallback: directe mappen (variantToPrice) op de targetVid
    if (prod.variantToPrice?.[targetVid] != null) {
      const price = Number(prod.variantToPrice[targetVid]);
      const compareAt = prod.variantToCompareAtPrice?.[targetVid] != null
        ? Number(prod.variantToCompareAtPrice[targetVid])
        : undefined;
      return {
        ...p,
        variantId: targetVid, // ⬅️ ook hier de test-variant
        price,
        compare_at_price: compareAt ?? p.compare_at_price ?? p.price
      };
    }

    // 3) geen prijsinfo? we updaten in elk geval de variantId zodat cart correct is
    return { ...p, variantId: targetVid };
  });
}




  // Cookie storage utility
  const cookieStorage = {
    save: function (cookieName, cookieValue) {
      document.cookie = `${cookieName}=${encodeURIComponent(
        JSON.stringify(cookieValue)
      )};path=/;max-age=604800`;
    },
    load: function (cookieName) {
      const cookieMatch = document.cookie.match(
        new RegExp(`${cookieName}=([^;]+)`)
      );
      try {
        return cookieMatch
          ? JSON.parse(decodeURIComponent(cookieMatch[1]))
          : [];
      } catch {
        return [];
      }
    },
  };

  // Update product slot display
  function updateProductSlotDisplay(productSlot, productData) {
    const productImage = productSlot.querySelector(".slot-image");
    const placeholderImage = productSlot.querySelector(".slot-placeholder-svg");
    const removeButton = productSlot.querySelector(".remove-selected");

    if (productData) {
      productImage.src = productData.image;
      productImage.style.display = "block";
      placeholderImage.style.display = "none";
      removeButton.style.display = "flex";
      productSlot.classList.add("filled");
    } else {
      productImage.style.display = "none";
      placeholderImage.style.display = "block";
      removeButton.style.display = "none";
      productSlot.classList.remove("filled");
    }
  }

  // Helper function: format badge price WITHOUT decimals if whole number
  // function formatBadgePrice(price) {
  //   if (price % 1 === 0) {
  //     return `${Math.round(price)} €`;
  //   } else {
  //     return `${price.toFixed(2)} €`;
  //   }
  // }

  function updateBundleTotalPrice(selectedProductsList) {
    const priceElement = document.getElementById("bundle-total-price");
    const compareElement = document.getElementById("bundle-compare-price");
    const pricingWrapper = document.querySelector(".bundle-price-list");
    const bundlePricing = document.querySelector(".bundle-pricing");
    const normalDiscountWrapper = document.querySelector(".normal-dicount-badge-wrapper");
    const bundleDiscountWrapper = document.querySelector(".bundle-dicount-wrapper");

    if (!priceElement || !pricingWrapper) return;

    // === NIEUW: pas AB-prijzen toe (simpel, zonder window.*) ===
    selectedProductsList = applyAbPricingFromDict(window.abconvertDict, selectedProductsList);
    // FIX: Always show the bundle-price-list section
    pricingWrapper.style.display = "block";

    // Unified badge display logic
    const shouldShowBadge = true;
    if (normalDiscountWrapper) {
      normalDiscountWrapper.style.display = shouldShowBadge ? "inline" : "none";
    }

    // FIX: If no products selected, show parent product price dynamically
    if (selectedProductsList.length === 0) {
      bundlePricing.classList.remove("show-bundle-discount");
      updateBundleNormalWrapperFromParentAB(); // ⬅️ update #bundle-total-price & #bundle-compare-price
      return;
    }


    // bundleDiscountWrapper.style.display = 'inline';
    bundlePricing.classList.add("show-bundle-discount");

    const totalPrice = selectedProductsList.reduce((total, product) => {
      return total + (product.price || 0);
    }, 0);

    const compareTotal = selectedProductsList.reduce((total, product) => {
      return total + (product.compare_at_price || product.price || 0);
    }, 0);

    // Bundle discount logic - total discount split between items
    const totalBundleDiscount = window.bundleDiscountValue || 0;
    const discountPerItem =
      selectedProductsList.length === 2 && totalBundleDiscount > 0
        ? totalBundleDiscount / 2
        : 0;

    const discountedTotal = totalPrice - totalBundleDiscount;

    if (selectedProductsList.length === 2 && totalBundleDiscount > 0) {
      // Show bundle discount pricing
      const bundleDiscountedPrice = document.getElementById("bundle-discounted-price");
      const bundleOriginalPrice = document.getElementById("bundle-original-price");

      if (bundleDiscountedPrice) {
        bundleDiscountedPrice.textContent = `${discountedTotal.toFixed(2).replace(".", ",")} €`;
      }
      if (bundleOriginalPrice) {
        bundleOriginalPrice.textContent = `${totalPrice.toFixed(2).replace(".", ",")} €`;
      }

      if (bundlePricing) {
        bundlePricing.classList.add("show-bundle-discount");
      }
    } else {
      // Show normal pricing when no discount applies
      const shouldShowCompare = compareTotal > totalPrice;

      priceElement.textContent = `${totalPrice.toFixed(2).replace(".", ",")} €`;

      if (compareElement) {
        compareElement.style.display = shouldShowCompare ? "inline" : "none";
        compareElement.textContent = `${compareTotal.toFixed(2).replace(".", ",")} €`;
      }

      if (bundlePricing) {
        bundlePricing.classList.remove("show-bundle-discount");
      }
    }
  }


  // Update add to cart button with loading states
  function updateAddToCartButton(selectedProductsList, isLoading = false) {
    const addToCartButton = document.getElementById("bundleAddToCart");
    if (!addToCartButton) return;

    if (isLoading) {
      addToCartButton.disabled = true;
      addToCartButton.textContent =
        window.theme?.strings?.adding || "Wird hinzugefügt...";
      addToCartButton.style.cssText = "pointer-events:none;opacity:0.7;";
      return;
    }

    const isReadyToAdd = selectedProductsList.length === MAXIMUM_PRODUCTS;

    if (isReadyToAdd) {
      addToCartButton.disabled = false;
      addToCartButton.textContent =
        window.theme?.strings?.add_to_cart || "In den Warenkorb";
      addToCartButton.style.cssText = "";
    } else {
      addToCartButton.disabled = true;
      addToCartButton.textContent =
        window.theme?.strings?.select_your_rings || "Wähle deine Ringe";
      addToCartButton.style.cssText = "";
    }
  }

  // ONLY ADDITION: Update in-stock text display
  function updateInStockText(selectedProductsList) {
    const inStockTextInfo = document.querySelector(".in-stock-text-info");
    if (!inStockTextInfo) return;

    if (selectedProductsList.length === MAXIMUM_PRODUCTS) {
      inStockTextInfo.innerHTML = `
        <div class="in-stock-indicator">
          <span class="stock-dot"></span>
          <span class="stock-text"> <span class="stock-green-text"> Auf Lager</span> in 1–2 Werktagen bei Dir</span>
        </div>
      `;
      inStockTextInfo.style.display = "block";
    } else {
      inStockTextInfo.style.display = "none";
    }
  }

  // Update before/after discount text display
  function updateDiscountText(selectedProductsList) {
    const beforeText = document.getElementById("before-discount-text");
    const afterText = document.getElementById("after-discount-text");

    // If neither element exists, return early
    if (!beforeText && !afterText) return;

    if (selectedProductsList.length >= 2) {
      // Show "after" text when 2 products selected
      if (beforeText) beforeText.style.display = "none";
      if (afterText) afterText.style.display = "inline";
    } else {
      // Show "before" text when 0-1 products selected
      if (beforeText) beforeText.style.display = "inline";
      if (afterText) afterText.style.display = "none";
    }
  }

  // Update entire bundle interface
  function updateBundleInterface(selectedProductsList, isLoading = false) {
    // Update product card selections with count display
    document.querySelectorAll(".bundle-product").forEach((productCard) => {
      const productId = productCard.dataset.productId;
      const selectionCount = selectedProductsList.filter(
        (product) => product.id === productId
      ).length;

      const isSelected = selectionCount > 0;
      productCard.classList.toggle("this-product-selected", isSelected);

      // Update ONLY the display text, nothing else
      if (isSelected) {
        const selectedText = productCard.querySelector(
          ".product-selected-texts"
        );
        if (selectedText) {
          selectedText.textContent =
            selectionCount > 1
              ? `${selectionCount}x hinzugefügt`
              : "hinzugefügt";
        }
      }
    });

    // NEW: Update discount price display based on selection count
    updateDiscountDisplay(selectedProductsList.length);

    // Keep ALL existing functionality unchanged
    const productSlots = document.querySelectorAll(".product-slot");
    productSlots.forEach((productSlot, slotIndex) => {
      updateProductSlotDisplay(productSlot, selectedProductsList[slotIndex]);
    });

    updateAddToCartButton(selectedProductsList, isLoading);
    updateInStockText(selectedProductsList);
    updateDiscountText(selectedProductsList);
    updateBundleTotalPrice(selectedProductsList);
  }

  // Handle product selection

  function selectProductFromCard(productCard) {
    const productId = productCard.dataset.productId;
    const mainProductId = productCard.dataset.mainProductId;
    const isAvailable = productCard.dataset.available === "true";

    if (!productId || !isAvailable || !mainProductId) return;

    // Get product data
    const productImage = productCard.querySelector(
      ".product-item__image-wrapper img"
    );
    const productTitle = productCard.querySelector(".product-item-meta__title");
    const variantId = productCard.dataset.variantId;
    const imageSource = productImage ? productImage.src : "";
    const productName = productTitle ? productTitle.textContent.trim() : "";

    let selectedProductsList = cookieStorage.load(BUNDLE_COOKIE_NAME);

    // Count how many times this product is already selected
    const existingCount = selectedProductsList.filter(
      (product) => product.id === productId
    ).length;

    const priceElement = productCard.querySelector("[data-product-price]");
    const productPrice = priceElement
      ? parseFloat(priceElement.dataset.productPrice)
      : 0;

    const comparePriceElement = productCard.querySelector(
      "[data-compare-price]"
    );
    const comparePrice = comparePriceElement
      ? parseFloat(comparePriceElement.dataset.comparePrice)
      : productPrice;

    if (existingCount >= 2) {
      // Product already selected twice, do nothing
      return;
    }

    if (existingCount === 0) {
      // First time selecting this product
      if (selectedProductsList.length >= MAXIMUM_PRODUCTS) {
        // Remove oldest product and shift remaining
        selectedProductsList.shift();
      }
      selectedProductsList.push({
        mainProductId: mainProductId,
        id: productId,
        variantId: variantId || productId,
        image: imageSource,
        name: productName,
        price: productPrice,
        compare_at_price: comparePrice,
      });
    } else if (existingCount === 1) {
      // Second time selecting this product
      if (selectedProductsList.length >= MAXIMUM_PRODUCTS) {
        // Remove oldest product and shift remaining
        selectedProductsList.shift();
      }
      selectedProductsList.push({
        mainProductId: mainProductId,
        id: productId,
        variantId: variantId || productId,
        image: imageSource,
        name: productName,
        price: productPrice,
        compare_at_price: comparePrice,
      });
    }

    cookieStorage.save(BUNDLE_COOKIE_NAME, selectedProductsList);
    updateBundleInterface(selectedProductsList);
  }

  // Remove product from slot
  function removeProductFromSlot(slotIndex) {
    let selectedProductsList = cookieStorage.load(BUNDLE_COOKIE_NAME);
    if (selectedProductsList[slotIndex]) {
      selectedProductsList.splice(slotIndex, 1);
      cookieStorage.save(BUNDLE_COOKIE_NAME, selectedProductsList);
      updateBundleInterface(selectedProductsList);
    }
  }



  //  Add selected bundle to cart
async function addSelectedBundleToCart() {
  const selectedProductsListRaw = cookieStorage.load(BUNDLE_COOKIE_NAME);
  if (selectedProductsListRaw.length !== MAXIMUM_PRODUCTS) return;

  // ✅ AB-prijzen/mapping toepassen (ongewijzigd)
  let selectedProductsList = selectedProductsListRaw;
  try {
    if (typeof abconvertDict !== "undefined" && abconvertDict) {
      selectedProductsList = applyAbPricingFromDict(abconvertDict, selectedProductsListRaw);
    }
  } catch (e) {
    console.warn("[AB] applyAbPricingFromDict failed:", e);
  }

  // ✅ Parent variant ID uit DOM (ongewijzigd)
  const bundleWrapper = document.querySelector(".ring-product-bundle");
  const parentVariantId = bundleWrapper?.dataset?.parentProduct || null;

  const bundleId = `${Date.now()}-${Math.floor(Math.random() * 1000)}`;
  updateBundleInterface(selectedProductsList, true); // UI loading state

  const toCents = (eur) => Math.round(Number(eur || 0) * 100);
  const preDiscountCents = Math.round(
    selectedProductsList.reduce((s, p) => s + Number(p.price || 0), 0) * 100
  );
  const discountCents = Math.round((window.bundleDiscountValue || 0) * 100);

  // 🔹 items[] opbouwen met IDENTIEKE prop-namen/waarden
  const items = [];
  let index = 0;

  for (const product of selectedProductsList) {
    let ab = null;
    try {
      if (typeof abconvertDict !== "undefined" && abconvertDict) {
        ab = getTestPricingForVariantFromDict(
          abconvertDict,
          String(product.mainProductId),
          String(product.variantId || product.id)
        );
      }
    } catch {}

    const unitEur    = ab?.price ?? product.price ?? 0;
    const compareEur = (ab?.compareAt != null) ? ab.compareAt : (product.compare_at_price ?? null);

    const props = {
      "_bundle-product": "True",
      "_bundleId": bundleId,
      "_bundleLineId": `${bundleId}-${index}`,
      "_ab_unit_price_cents": String(toCents(unitEur)),
      "_bundle_pre_discount_total_cents": String(preDiscountCents),
      "_bundle_discount_cents": String(discountCents),
      "_bundle_post_discount_total_cents": String(Math.max(preDiscountCents - discountCents, 0)),
    };
    if (compareEur != null) props["_ab_compare_at_cents"] = String(toCents(compareEur));
    if (ab?.experimentId)  props["_ab_exp"] = ab.experimentId;
    if (ab?.groupIndex != null) props["_ab_group"] = String(ab.groupIndex);

    items.push({ id: product.variantId, quantity: 1, properties: props });
    index++;
  }

  // 🔹 Parent in dezelfde batch, met dezelfde prop-namen
  if (parentVariantId) {
    items.push({
      id: parentVariantId,
      quantity: 1,
      properties: {
        "_Bundle Parent Product": "True",
        "_bundleId": bundleId,
        "_bundle_pre_discount_total_cents": String(preDiscountCents),
        "_bundle_discount_cents": String(discountCents),
        "_bundle_post_discount_total_cents": String(Math.max(preDiscountCents - discountCents, 0)),
      }
    });
  }

  // ✨ Vraag sections meteen mee in déze POST (geen extra GET nodig)
  const sectionsParam = "mini-cart,cart-count"; // laat dit exact je sectienamen zijn
  const sectionsUrl = window.location.pathname; // Shopify adviseert dit mee te geven

  try {
    const addRes = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        items,
        sections: sectionsParam,
        sections_url: sectionsUrl
      })
    });

    if (!addRes.ok) {
      const errorData = await addRes.json().catch(() => ({}));
      throw new Error(errorData.description || "Failed to add items to cart");
    }

    const addJson = await addRes.json();

    // 🧩 Prefer: sections direct uit add-respons
    let sectionsData = addJson?.sections;

    // Fallback (zeldzaam: oude setups sturen geen sections terug)
    if (!sectionsData) {
      const fallbackRes = await fetch(
        `${window.themeVariables.routes.cartUrl}?sections=${encodeURIComponent(sectionsParam)}`,
        { credentials: "same-origin", headers: { "X-Requested-With": "XMLHttpRequest" } }
      );
      sectionsData = await fallbackRes.json();
    }

    // Mini-cart DOM vervangen
    const cartDrawer = document.querySelector('[data-drawer-id="mini-cart"], #mini-cart, .mini-cart');
    if (cartDrawer && sectionsData["mini-cart"]) {
      const newCartContent = new DOMParser()
        .parseFromString(sectionsData["mini-cart"], "text/html")
        .querySelector('[data-drawer-id="mini-cart"], #mini-cart, .mini-cart');
      if (newCartContent) cartDrawer.innerHTML = newCartContent.innerHTML;
    }

    // Cart bubble uit cart-count section
    if (sectionsData["cart-count"]) {
      const tmp = new DOMParser().parseFromString(sectionsData["cart-count"], "text/html");
      const newCountEl = tmp.querySelector("[data-cart-count], .cart-count, .header__cart-count, .cart-bubble");
      const newCount = newCountEl ? newCountEl.textContent.trim() : null;
      if (newCount != null) {
        document
          .querySelectorAll("[data-cart-count], .cart-count, .header__cart-count, .cart-bubble")
          .forEach((el) => {
            el.textContent = newCount;
            el.style.display = Number(newCount) > 0 ? "flex" : "none";
            el.style.transform = "scale(1.2)";
            setTimeout(() => (el.style.transform = "scale(1)"), 200);
          });
      }
    }

    // Clear selectie & UI herstellen
    cookieStorage.save(BUNDLE_COOKIE_NAME, []);
    updateBundleInterface([]);

    // Drawer openen
    const cartDrawerEl = document.querySelector('[data-drawer-id="mini-cart"], #mini-cart, .mini-cart');
    if (cartDrawerEl) {
      cartDrawerEl.setAttribute("open", "");
      cartDrawerEl.classList.add("is-open");
      if (window.theme?.cartDrawer?.open) window.theme.cartDrawer.open();
    }

  } catch (error) {
    console.error("Bundle add to cart (single-call) error:", error);
    alert("Please add a parent product to the section BD Product Bundle.");
    updateBundleInterface(cookieStorage.load(BUNDLE_COOKIE_NAME));
  }
}




  // Initialize bundle selector
  function initializeBundleSelector() {
    updateBundleInterface(cookieStorage.load(BUNDLE_COOKIE_NAME));

    // Product card events
    document.querySelectorAll(".bundle-product").forEach((productCard) => {
      productCard.addEventListener("click", function (clickEvent) {
        const excludedSelectors = [
          ".variant-model",
          ".quick-view",
          ".variant-image-section",
          ".variant-model-image",
        ];

        const isExcluded = excludedSelectors.some((selector) =>
          clickEvent.target.closest(selector)
        );

        if (isExcluded) {
          return; // Don't trigger selection
        }

        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        selectProductFromCard(productCard);
      });
    });

    // Product slot events
    document
      .querySelectorAll(".product-slot")
      .forEach(function (productSlot, slotIndex) {
        productSlot.style.pointerEvents = "none";

        const removeButton = productSlot.querySelector(".remove-selected");
        if (removeButton) {
          removeButton.style.pointerEvents = "auto";
          removeButton.addEventListener("click", function (clickEvent) {
            clickEvent.preventDefault();
            clickEvent.stopPropagation();
            removeProductFromSlot(slotIndex);
          });
        }
      });

    // Add to cart button event
    const addToCartButton = document.getElementById("product-select-section");
    const scrollTarget = document.querySelector(".ring-product-bundle");

    if (addToCartButton && scrollTarget) {
      addToCartButton.addEventListener("click", function (clickEvent) {
        clickEvent.preventDefault();

        addSelectedBundleToCart();

        // Scroll with delay after cart logic
        setTimeout(function () {
          // Check window width at time of click
          const isMobile = window.innerWidth <= 768;
          const offset = isMobile ? 50 : 180;

          const elementTop =
            scrollTarget.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: elementTop - offset,
            behavior: "smooth",
          });
        }, 500);
      });
    }
  }

  // NEW: Function to show/hide discount prices
  function updateDiscountDisplay(selectedCount) {
    // Only apply discount state if bundleDiscountValue is actually set and > 0
    const discountActive =
      window.bundleDiscountValue && Number(window.bundleDiscountValue) > 0;

    document.querySelectorAll(".bundle-product").forEach((productCard) => {
      const priceList = productCard.querySelector(".price-list");
      const isSelected = productCard.classList.contains(
        "this-product-selected"
      );

      if (priceList) {
        if (selectedCount === 2 && isSelected && discountActive) {
          priceList.classList.add("show-discount");
        } else {
          priceList.classList.remove("show-discount");
        }
      }
    });
  }

  // Start bundle selector
  initializeBundleSelector();
});


// Sticky bar functionality
function updateStickyBar() {
  const announcementBar = document.getElementById("announcement-bar");

  if (!stickyBar || !announcementBar) return;
  if (window.innerWidth < 992) return stickyBar.removeAttribute("style");

  const isFixed = announcementBar.classList.contains("fade");

  if (isFixed) {
    // 👉 Fixed mode
    stickyBar.style.cssText = "position:fixed;top:0;left:0;width:100%;z-index:5;";
    sectionWrapper.classList.add("is-fixed");
  } else {
    // 👉 Sticky mode
    stickyBar.style.cssText = `position:sticky;top:${announcementBar.offsetHeight}px;left:0;width:100%;z-index:5;`;
    sectionWrapper.classList.remove("is-fixed");
  }
}

["resize", "scroll"].forEach(event =>
  window.addEventListener(event, updateStickyBar)
);
// Consolidated initialization
document.addEventListener("DOMContentLoaded", function () {
  // Sticky bar
  updateStickyBar();

  // Video modal
  const videoOpenButton = document.getElementById("openVideoModal");
  const videoCloseButton = document.getElementById("closeVideoModal");
  const videoModal = document.getElementById("videoModal");

  if (videoOpenButton && videoCloseButton && videoModal) {
    videoOpenButton.addEventListener("click", function () {
      videoModal.style.display = "flex";
      document.body.classList.add("video-modal-open");
      const videoElement = videoModal.querySelector("video");
      if (videoElement) {
        videoElement.currentTime = 0;
        videoElement
          .play()
          .catch((error) => console.warn("Video autoplay failed:", error));
      }
    });

    const closeVideoModal = function () {
      videoModal.style.display = "none";
      const videoElement = videoModal.querySelector("video");
      if (videoElement) videoElement.pause();
      document.body.classList.remove("video-modal-open");
    };

    videoCloseButton.addEventListener("click", closeVideoModal);
    window.addEventListener("click", function (clickEvent) {
      if (clickEvent.target === videoModal) closeVideoModal();
    });
  }

  // Variant modal
  const variantModels = document.querySelectorAll(".variant-model");
  const variantModal = document.getElementById("variantModal");
  const variantModalClose = variantModal?.querySelector(".modal-close");

  if (variantModal && variantModalClose) {
    variantModels.forEach((variantModel) => {
      variantModel.addEventListener("click", function () {
        variantModal.style.display = "flex";
      });
    });

    variantModalClose.addEventListener("click", function () {
      variantModal.style.display = "none";
    });
  }
});

